import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const numericValue = z
  .union([z.number(), z.string()])
  .transform(value => Number(value))
  .refine(value => Number.isFinite(value), 'Valor numérico inválido')

export const ruralPropertyAreaUnit = z.enum(['square_meter', 'hectare'])

export const ruralPropertyObject = z.object({
  id: z.string().uuid(),
  residenceId: z.string().uuid(),
  totalAreaValue: numericValue.nullish(),
  totalAreaUnit: ruralPropertyAreaUnit.nullish(),
  cropAreaValue: numericValue.nullish(),
  cropAreaUnit: ruralPropertyAreaUnit.nullish(),
  isRented: z.boolean().nullish(),
  ownerCitizenId: z.string().uuid().nullish(),
  incraNumber: z.string().max(32).nullish(),
  iptuRegistryNumber: z.string().max(32).nullish(),
  propertyRegistrationNumber: z.string().max(32).nullish(),
  primaryProducerRegistration: z.string().max(32).nullish(),
  timeAtPropertyYears: z.number().int().nullish(),
  acquisitionMethod: z.string().max(50).nullish(),
  interestedInOtherActivity: z.boolean().nullish(),
  otherActivityInterest: z.string().max(255).nullish(),
  hasWaterReservoirForFire: z.boolean().nullish(),
  hasInternetAccess: z.boolean().nullish(),
  hasPhoneAccess: z.boolean().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  clientId: z.number().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  residence: z
    .object({
      id: z.string().nullish(),
      title: z.string().nullish(),
      fullAddress: z.string().nullish(),
      observation: z.string().nullish(),
    })
    .nullish(),
  residenceTitle: z.string().nullish(),
  residenceFullAddress: z.string().nullish(),
  residenceObservation: z.string().nullish(),
})

export const ruralPropertyUpsertInputObject = z.object({
  id: z.string().uuid().nullish(),
  residenceId: z.string().uuid(),
  totalAreaValue: numericValue.nullish(),
  totalAreaUnit: ruralPropertyAreaUnit.nullish(),
  cropAreaValue: numericValue.nullish(),
  cropAreaUnit: ruralPropertyAreaUnit.nullish(),
  isRented: z.boolean().nullish(),
  ownerCitizenId: z.string().uuid().nullish(),
  incraNumber: z.string().max(32).nullish(),
  iptuRegistryNumber: z.string().max(32).nullish(),
  propertyRegistrationNumber: z.string().max(32).nullish(),
  primaryProducerRegistration: z.string().max(32).nullish(),
  timeAtPropertyYears: z.number().int().nullish(),
  acquisitionMethod: z.string().max(50).nullish(),
  interestedInOtherActivity: z.boolean().nullish(),
  otherActivityInterest: z.string().max(255).nullish(),
  hasWaterReservoirForFire: z.boolean().nullish(),
  hasInternetAccess: z.boolean().nullish(),
  hasPhoneAccess: z.boolean().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
})

export const ruralPropertyResidenceInputObject = ruralPropertyUpsertInputObject.omit({
  residenceId: true,
})

export type RuralPropertyType = z.infer<typeof ruralPropertyObject>
export type RuralPropertyUpsertInput = z.infer<typeof ruralPropertyUpsertInputObject>
